<template>
  <div>
    <div class="page-content border-bottom">
      <!-- 顶部搜索框 -->
      <div>
        <el-form :inline="true" :model="searchInfo" class="demo-form-inline">
          <el-form-item label="会员姓名">
            <el-input v-model="searchInfo.memName" placeholder="请输入会员姓名" class="form-item-width" clearable></el-input>
          </el-form-item>
          <el-form-item class="right-btns">
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 评论展示区域 -->
    <div class="page-content margin-top">
      <el-card style="margin-bottom: 10px;" v-for="review in reviews" :key="review.id" class="review-card">
        <div class="comment">
          <el-avatar :size="54" :src="require('@/assets/touxiang.png')" class="avatar"></el-avatar>
          <div class="top">
            <p>
              <span class="name">{{ review.memName }}</span>
              <el-rate v-model="review.commentLevel" disabled ></el-rate> 
              <span class="time">发布时间：{{ review.createTime }}</span> 
            </p>                   
            <div class="bottom">{{ review.commentContent }}</div>
          </div>
        </div>
      </el-card>
    
      
      <!-- 分页组件 -->
      <div>
        <Pagination
          :total="dataTotal"
          :page="searchInfo.page"
          :limit="searchInfo.limit"
          @pagination="onChangePages"
        />
      </div>
    </div>

    
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { getComment } from '@/api/comment.js'
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      // 查询数据
      searchInfo: {
        memName:'',
        page: 1,
        size: 20,
      },
      
      //评论列表
      reviews:[],
      dataTotal:0

    }
  },
  mounted() {
    // 查询数据
    this.onSearch()
  },
  methods: {
    // 查询
    onSearch() {
      this.searchInfo.page = 1
      this.onGetDataList()
    },
    // 获取评论列表
    async onGetDataList() {
      const data = await getComment(this.searchInfo)
      this.reviews = data.data.records
      this.dataTotal = data.data.total
    },
    
    // 重置
    onReset() {
      this.searchInfo.memName = ''
      this.onSearch()
    },
    // 分页方法
    onChangePages(pageInfo) {
      const { page, limit } = pageInfo
      this.searchInfo.page = page
      this.searchInfo.size = limit
      this.onGetDataList()
    },
   
  },
}
</script>

<style lang="less" scoped>
.form-item-width {
  width: 250px;
}
.right-btns {
  position: absolute;
  right: 20px !important;
}
.el-form-item {
  font-weight: bold;
  margin: 0 20px 4px 10px !important;
}
.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}
.margin-top {
  margin-top: -15px;

  .comment{
    display: flex;

    .avatar{
      margin-right: 20px;
      margin-top: 14px;
    }

    .top{
       
      p{
        display: flex;
        align-items: center;

        .name{
          margin-right: 10px;
          font-size: 20px;
          font-weight: 560;
        }

        .time{
          margin-left: 40px;
          font-size: 13px;
        }
      }
    }
  }
    
}


</style>